import { useInfiniteQuery } from '@tanstack/react-query'
import { listInAppNotifications } from '../api'
import type { InAppNotificationListResponse } from '../api'
import { notificationQueryKeys } from './notificationQueryKeys'

const DEFAULT_LIMIT = 30

export const useNotificationsList = (enabled: boolean, headId: string | null) => {
  return useInfiniteQuery<InAppNotificationListResponse, Error, InAppNotificationListResponse>(
    [...notificationQueryKeys.list(), headId],
    ({ pageParam }) =>
      listInAppNotifications({
        limit: DEFAULT_LIMIT,
        cursor: pageParam as string | undefined,
      }),
    {
      getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
      enabled,
      staleTime: 0,
    }
  )
}
